// Оплата лицензий была в тестовом режиме с 24.09.2026: флаг включает метку
// «Тестовый режим» на карточке на «Заказах», подпись в меню и предупреждение
// на странице оплаты. Раздел открыт по-настоящему 19.10.2026 (Глеб, после
// новой редакции договора). Если понадобится снова закрыть — поставить true.
export const LICENSE_PAYMENT_TEST_MODE = false

export default LICENSE_PAYMENT_TEST_MODE
